// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2t2QM","input":"styles_input__nHe1Z"};